import React, { Fragment, useCallback, useMemo } from 'react'
import { toast } from 'react-toastify'
import ReactTooltip from 'react-tooltip'

import { StudentService } from 'services/student'
import Table from './Table'

const StudentsTable = ({
  studentsList,
  setStudentsList,
  onDeleteClick,
  isDeleteButtonVisible = false,
  deleteOnAPI = true,
}) => {
  const handleDeleteById = useCallback(async (id) => {
    await StudentService.deleteById(id)
  }, [])

  const handleDeleteItem = useCallback(
    async (dataIndex, id) => {
      try {
        if (onDeleteClick) onDeleteClick(id)

        setStudentsList((prev) => {
          const prevCopy = [...prev]
          prevCopy.splice(dataIndex, 1)
          return prevCopy
        })

        if (id && deleteOnAPI) {
          await handleDeleteById(id)
        }
      } catch (e) {
        toast.error(e)
      }
    },
    [deleteOnAPI, handleDeleteById, onDeleteClick, setStudentsList]
  )

  const handleRenderItem = useCallback(
    (key, item, dataIndex) => {
      switch (key) {
        case '-':
          return (
            <a
              href="#!"
              onClick={() => handleDeleteItem(dataIndex, item.Id)}
              style={{ color: '#E94B4B', fontWeight: 600 }}
            >
              X
            </a>
          )

        case 'Status':
          let color = '#f00'
          if (item[key] === 'Aprovado') color = '#18b840'
          else if (item[key] === 'Lista de espera') color = '#f90'

          return (
            <div className="student-status">
              <div
                className="dot"
                style={{
                  display: 'block',
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  background: color,
                  marginRight: '5px',
                }}
              />
              <span className="status">{item[key]}</span>
            </div>
          )

        case 'SiglaInstituicao':
          return (
            <Fragment>
              <ReactTooltip effect="float" data-place="top" />
              <p style={{ fontWeight: 400 }} data-tip={item.NomeInstituicao}>
                {item[key]}
              </p>
            </Fragment>
          )

        case 'Modalidade':
          return (
            <Fragment>
              <ReactTooltip effect="float" data-place="top" />
              <span data-tip={item[key]}>
                {String(item[key]).length > 18 ? String(item[key]).substring(0, 18) + '...' : item[key]}
              </span>
            </Fragment>
          )

        default:
          return item[key]
      }
    },
    [handleDeleteItem]
  )

  const headers = useMemo(() => {
    let result = [
      { width: '10%', key: 'DataConsulta', label: 'Data' },
      { 
        width: '100px', 
        key: 'Status', 
        label: 'Status' 
      },
      { width: '15%', key: 'CodigoInscricaoENEM', label: 'Inscrição' },
      { width: '30%', key: 'NomeInscrito', label: 'Nome do Estudante' },
      { width: '15%', key: 'SiglaInstituicao', label: 'IES' },
      { width: '20%', key: 'NomeCurso', label: 'Curso' },
      { width: '15%', key: 'NotaCandidato', label: 'Nota' },
      { width: '5%', key: 'Classificacao', label: 'Classificação' },
      { 
        width: '5%', 
        label: 'Ano',
        render: (item) => {
          if (item.CodigoInscricaoENEM != null && item.CodigoInscricaoENEM.length > 2) {
            const year = parseInt(item.CodigoInscricaoENEM.slice(0, 2)) + 1
            return `20${year}`
          }

          return null
        }
      },
      { width: '15%', key: 'Modalidade', label: 'Modalidade' },
    ]

    if (isDeleteButtonVisible) {
      result.push({ width: '5%', key: '-', label: 'Ações' })
    }

    return result
  }, [isDeleteButtonVisible])

  return (
    <Fragment>
      <p style={{ textAlign: 'center', color: '#000' }}>
        <strong> </strong>
        <span style={{ fontWeight: 300 }}>
          
        </span>
      </p>
      <Table headers={headers} data={studentsList} renderItem={handleRenderItem} />
    </Fragment>
  )
}

export default StudentsTable
